module.exports = __webpack_public_path__ + "img/energy002.7fe670ee.png";